import { Login } from './login';

export class LoginSerializer {

  fromJson(json: any): Login {
    const sf = new Login();
    if (typeof json.success !== 'undefined') {
        sf.success = json.success;
        sf.data = this.toJson(json.data);
        return sf;
    } else {
        return this.toJson(json);
    }
  }

  toJson(sf: Login): any {
    if (typeof sf === 'object') {
      return {
        person_id: sf.person_id,
        applyment_id: sf.applyment_id,
        session_id: sf.session_id,
        lgpd_popup: sf.lgpd_popup,
        selective_process_id: sf.selective_process_id,
        lgpdDataFromPopUp: sf.lgpdDataFromPopUp
      };
    } else {
      return sf;
    }
  }
}
